import { render, staticRenderFns } from "./nuclearElectricity.vue?vue&type=template&id=133665a6&scoped=true"
import script from "./nuclearElectricity.vue?vue&type=script&lang=js"
export * from "./nuclearElectricity.vue?vue&type=script&lang=js"
import style0 from "./nuclearElectricity.vue?vue&type=style&index=0&id=133665a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133665a6",
  null
  
)

export default component.exports